import React, { useState, useEffect } from 'react'

import './Loader.css'

const Loader = () => {
  // const [state, setState] = useState(null);

  return (
    <div className="Loader">
      <div className="spinner" />
    </div>
  );
};

export default Loader;
